import KREATIVAN from "../../../assets/images/KREATIVAN.png";
import accredited from "../../../assets/images/032.jpg";
import advance from "../../../assets/images/018_1.jpg";
import aws from "../../../assets/images/033.jpg";
import bedrock from "../../../assets/images/019_1.jpg";
import catalyst from "../../../assets/images/009.jpg";
import cognitor from "../../../assets/images/006_1.jpg";
import connect from "../../../assets/images/015_1.jpg";
import ctl from "../../../assets/images/017_1.jpg";
import deinde from "../../../assets/images/020.jpg";
import educ from "../../../assets/images/008_1.jpg";
import ffsi from "../../../assets/images/034.jpg";
import fucl from "../../../assets/images/035.jpg";
import goteso from "../../../assets/images/016_1.jpg";
import hp from "../../../assets/images/002_1.jpg";
import ibm from "../../../assets/images/021.jpg";
import impinge from "../../../assets/images/013_1.jpg";
import infosys from "../../../assets/images/022.jpg";
import infotech from "../../../assets/images/003.jpg";
import jaro from "../../../assets/images/023.jpg";
import ma from "../../../assets/images/005_1.jpg";
import member from "../../../assets/images/031.jpg";
import mphasis from "../../../assets/images/024.jpg";
import natron from "../../../assets/images/012.jpg";
import netsmartz from "../../../assets/images/025.jpg";
import ohic from "../../../assets/images/004.jpg";
import promatics from "../../../assets/images/011.jpg";
import radsol from "../../../assets/images/010.jpg";
import redhat from "../../../assets/images/redhat.png";
import s from "../../../assets/images/028.jpg";
import smartdata from "../../../assets/images/026.jpg";
import solitaire from "../../../assets/images/014.jpg";
import ta from "../../../assets/images/027.jpg";
import tata from "../../../assets/images/001.jpg";
import topper from "../../../assets/images/029.jpg";
import wipro from "../../../assets/images/030.jpg";
import zapbuild from "../../../assets/images/007_1.jpg";
import thsc from "../../../assets/images/thsc.png";
import radisson from "../../../assets/images/rad.png";

export const MouData = [
  {
    id: 1,
    image: tata,
  },
  {
    id: 2,
    image: hp,
  },
  {
    id: 3,
    image: infotech,
  },
  {
    id: 4,
    image: ohic,
  },
  {
    id: 5,
    image: ma,
  },
  {
    id: 6,
    image: cognitor,
  },
  {
    id: 7,
    image: zapbuild,
  },
  {
    id: 8,
    image: educ,
  },
  {
    id: 9,
    image: catalyst,
  },
  {
    id: 10,
    image: radsol,
  },
  {
    id: 11,
    image: promatics,
  },
  {
    id: 12,
    image: natron,
  },
  {
    id: 13,
    image: impinge,
  },
  {
    id: 14,
    image: solitaire,
  },
  {
    id: 15,
    image: connect,
  },
  {
    id: 16,
    image: goteso,
  },
  {
    id: 17,
    image: ctl,
  },
  {
    id: 18,
    image: advance,
  },
  {
    id: 19,
    image: bedrock,
  },
  {
    id: 20,
    image: deinde,
  },
  {
    id: 21,
    image: ibm,
  },
  {
    id: 22,
    image: infosys,
  },
  {
    id: 23,
    image: jaro,
  },
  {
    id: 24,
    image: mphasis,
  },
  {
    id: 25,
    image: netsmartz,
  },
  {
    id: 26,
    image: smartdata,
  },
  {
    id: 27,
    image: deinde,
  },
  {
    id: 28,
    image: ta,
  },
  {
    id: 29,
    image: s,
  },
  {
    id: 30,
    image: topper,
  },
  {
    id: 31,
    image: wipro,
  },
  {
    id: 32,
    image: member,
  },
  {
    id: 33,
    image: accredited,
  },
  {
    id: 34,
    image: aws,
  },
  {
    id: 35,
    image: ffsi,
  },
  {
    id: 36,
    image: fucl,
  },
  {
    id: 37,
    image: redhat,
  },
  {
    id: 38,
    image: KREATIVAN,
  },
  {
    id: 39,
    image: thsc,
  },
  {
    id: 40,
    image: radisson,
  },
];
